(function () {
  "use strict";
  if (customElements.get("range-slider")) return;

  customElements.define(
    "range-slider",
    class extends HTMLElement {
      constructor() {
        super();
        this.resizeFilters = window.theme.debounce(this.handleResize.bind(this), 50);
        this.onMoveEvent = (e) => this.onMove(e);
        this.onStopEvent = (e) => this.onStop(e);
        this.onStartEvent = (e) => this.onStart(e);

        this.startX = 0;
        this.x = 0;
        this.step = 0;

        // removed normalizeFact hack
        this.handleW = 0;
        this.maxX = 0;
      }

      connectedCallback() {
        this.touchLeft = this.querySelector("[data-range-left]");
        this.touchRight = this.querySelector("[data-range-right]");
        this.lineSpan = this.querySelector("[data-range-line]");

        this.min = parseFloat(this.getAttribute("data-se-min"));
        this.max = parseFloat(this.getAttribute("data-se-max"));

        let minVal = this.hasAttribute("data-se-min-value")
          ? parseFloat(this.getAttribute("data-se-min-value"))
          : this.min;
        let maxVal = this.hasAttribute("data-se-max-value")
          ? parseFloat(this.getAttribute("data-se-max-value"))
          : this.max;

        if (minVal < this.min) minVal = this.min;
        if (maxVal > this.max) maxVal = this.max;
        if (minVal > maxVal) minVal = maxVal;

        if (this.getAttribute("data-se-step"))
          this.step = Math.abs(parseFloat(this.getAttribute("data-se-step")));

        // compute geometry
        this.handleW = this.touchLeft.offsetWidth;
        this.maxX = this.offsetWidth - this.handleW; // full travel width

        this.reset();

        document.addEventListener("theme:resize", this.resizeFilters);

        this.setMinValue(minVal);
        this.setMaxValue(maxVal);

        this.touchLeft.addEventListener("mousedown", this.onStartEvent);
        this.touchRight.addEventListener("mousedown", this.onStartEvent);
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: false });
        this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: false });

        this.classList.add("is-initialized");
      }

      handleResize() {
        const minVal = parseFloat(this.getAttribute("data-se-min-value"));
        const maxVal = parseFloat(this.getAttribute("data-se-max-value"));

        this.handleW = this.touchLeft.offsetWidth;
        this.maxX = this.offsetWidth - this.handleW;

        this.setMinValue(minVal);
        this.setMaxValue(maxVal);
      }

      reset() {
        // place at true edges
        this.touchLeft.style.left = "0px";
        this.touchRight.style.left = this.maxX + "px";

        this.lineSpan.style.marginLeft = "0px";
        this.lineSpan.style.width = this.maxX + "px";

        this.startX = 0;
        this.x = 0;
      }

      setMinValue(val) {
        const ratio = (val - this.min) / (this.max - this.min);
        const left = Math.round(ratio * this.maxX);

        this.touchLeft.style.left = left + "px";
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
        this.lineSpan.style.width = (this.touchRight.offsetLeft - this.touchLeft.offsetLeft) + "px";

        this.setAttribute("data-se-min-value", val);
      }

      setMaxValue(val) {
        const ratio = (val - this.min) / (this.max - this.min);
        const left = Math.round(ratio * this.maxX);

        this.touchRight.style.left = left + "px";
        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
        this.lineSpan.style.width = (this.touchRight.offsetLeft - this.touchLeft.offsetLeft) + "px";

        this.setAttribute("data-se-max-value", val);
      }

      onStart(e) {
        e.preventDefault();
        let ev = e.touches ? e.touches[0] : e;

        if (e.currentTarget === this.touchLeft) {
          this.x = this.touchLeft.offsetLeft;
        } else if (e.currentTarget === this.touchRight) {
          this.x = this.touchRight.offsetLeft;
        }

        this.startX = ev.pageX - this.x;
        this.selectedTouch = e.currentTarget;

        document.addEventListener("mousemove", this.onMoveEvent);
        document.addEventListener("mouseup", this.onStopEvent);
        document.addEventListener("touchmove", this.onMoveEvent, { passive: false });
        document.addEventListener("touchend", this.onStopEvent);
      }

      onMove(e) {
        let ev = e.touches ? e.touches[0] : e;
        this.x = ev.pageX - this.startX;

        if (this.selectedTouch === this.touchLeft) {
          // allow edge-to-edge and thumbs can touch
          if (this.x > this.touchRight.offsetLeft) this.x = this.touchRight.offsetLeft;
          if (this.x < 0) this.x = 0;
          this.selectedTouch.style.left = this.x + "px";
        } else if (this.selectedTouch === this.touchRight) {
          if (this.x < this.touchLeft.offsetLeft) this.x = this.touchLeft.offsetLeft;
          if (this.x > this.maxX) this.x = this.maxX;
          this.selectedTouch.style.left = this.x + "px";
        }

        this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px";
        this.lineSpan.style.width = (this.touchRight.offsetLeft - this.touchLeft.offsetLeft) + "px";

        this.calculateValue();

        if (this.getAttribute("on-change")) {
          new Function("min, max", this.getAttribute("on-change"))(
            this.getAttribute("data-se-min-value"),
            this.getAttribute("data-se-max-value")
          );
        }
        this.onChange(this.getAttribute("data-se-min-value"), this.getAttribute("data-se-max-value"));
      }

      onStop() {
        document.removeEventListener("mousemove", this.onMoveEvent);
        document.removeEventListener("mouseup", this.onStopEvent);
        document.removeEventListener("touchmove", this.onMoveEvent);
        document.removeEventListener("touchend", this.onStopEvent);
        this.selectedTouch = null;

        this.calculateValue();
        this.onChanged(this.getAttribute("data-se-min-value"), this.getAttribute("data-se-max-value"));
      }

      onChange(minV, maxV) {
        const holder = this.closest("[data-range-holder]");
        if (!holder) return;
        const fMin = holder.querySelector("[data-field-price-min]");
        const fMax = holder.querySelector("[data-field-price-max]");
        if (fMin && fMax) {
          fMin.value = parseInt(minV);
          fMax.value = parseInt(maxV);
        }
      }

      onChanged() {
        if (this.hasAttribute("data-range-filter-update")) {
          this.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: true }));
        }
      }

      calculateValue() {
        // map thumb positions to values using the full travel width
        const leftRatio = this.touchLeft.offsetLeft / this.maxX;
        const rightRatio = this.touchRight.offsetLeft / this.maxX;

        let minV = leftRatio * (this.max - this.min) + this.min;
        let maxV = rightRatio * (this.max - this.min) + this.min;

        if (this.step !== 0) {
          minV = this.step * Math.round(minV / this.step);
          maxV = this.step * Math.round(maxV / this.step);
        }

        this.setAttribute("data-se-min-value", minV);
        this.setAttribute("data-se-max-value", maxV);
      }

      disconnectedCallback() {
        document.removeEventListener("theme:resize", this.resizeFilters);
        document.removeEventListener("mousemove", this.onMoveEvent);
        document.removeEventListener("mouseup", this.onStopEvent);
        document.removeEventListener("touchmove", this.onMoveEvent);
        document.removeEventListener("touchend", this.onStopEvent);

        this.touchLeft?.removeEventListener("mousedown", this.onStartEvent);
        this.touchRight?.removeEventListener("mousedown", this.onStartEvent);
        this.touchLeft?.removeEventListener("touchstart", this.onStartEvent);
        this.touchRight?.removeEventListener("touchstart", this.onStartEvent);
      }
    }
  );
})();
